import { z } from "zod";
import { ZodErrorMessageEnumValue } from "./enums.js";
export const createAppClinteSchema = z.object({
  clientName: z
    .string({ required_error: ZodErrorMessageEnumValue.REQUIRED })
});